import {
  Checkbox,
  FormControl,
  FormControlLabel,
  useTheme,
} from "@mui/material";
import { Controller } from "react-hook-form";
import { CheckboxInputProps } from "./types";
import ErrorMessage from "../ErrorMessage";
import { setCheckboxValue } from "@/redux-store/cart/cartSlice.ts";
import { useAppDispatch } from "@/redux-store/hooks.ts";

const CheckboxInput = ({
  label,
  name,
  control,
  onChange,
  checked,
}: CheckboxInputProps) => {
  const theme = useTheme();
  const dispatch = useAppDispatch();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const { value, onChange: fieldOnChange, ...other } = field;

        const handleChange = (
          _: React.SyntheticEvent<Element, Event>,
          checked: boolean
        ) => {
          fieldOnChange(checked);
          dispatch(setCheckboxValue(checked));
          onChange?.(checked);
        };

        return (
          <FormControl
            error={!!fieldState.error}
            sx={{ position: "relative", width: "100%" }}
          >
            <FormControlLabel
              {...other}
              control={<Checkbox checked={checked} />}
              label={label}
              onChange={handleChange}
              sx={{
                "& .MuiCheckbox-root": {
                  color: "#D0D5DD",
                  borderRadius: "16px",
                  "&.Mui-checked": {
                    color: theme.palette.primary.main,
                  },
                },
                "& .MuiFormControlLabel-label": {
                  fontSize: "1rem",
                },
              }}
            />
            {fieldState.error?.message && (
              <ErrorMessage message={fieldState.error.message} />
            )}
          </FormControl>
        );
      }}
    />
  );
};

export default CheckboxInput;
